import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialContractCloseFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ContractCloseFilterData from "./ContractCloseFilterData";

const ContractCloseFilter = ({ filterData, activeTab, onSetFilterData, onCallApiAgain, from }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialContractCloseFilterData);

  useEffect(() => {
    const handleClose = () => setIsSidebarOpen(false);
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  // Handle simple filter changes
  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  // 🔥 Clean payload before sending to API
  const getCleanPayload = (data) => {
    const payload = { ...data };

    // Handle object-based fields (convert to ID only)
    if (payload.property?.id !== undefined) {
      payload.property = payload.property.id || null;
    }

    if (payload.contact?.id !== undefined) {
      payload.contact = payload.contact.id || null;
    }

    if (payload.acquisition_contact?.id !== undefined) {
      payload.acquisition_contact = payload.acquisition_contact.id || null;
    }

    if (payload.disposition_contact?.id !== undefined) {
      payload.disposition_contact = payload.disposition_contact.id || null;
    }

    return payload;
  };

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));

    const cleanPayload = getCleanPayload(filterData);
    onCallApiAgain(cleanPayload);

    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      // Tab 0 fields
      current_phase: value?.current_phase || "",
      next_action: value?.next_action || "",

      // Common fields
      property: value?.property?.id === null
        ? { id: "", name: "" }
        : value?.property || { id: "", name: "" },

      contact: value?.contact?.id === null
        ? { id: "", name: "" }
        : value?.contact || { id: "", name: "" },

      // Tab 2 fields
      acquisition_contact: value?.acquisition_contact?.id === null
        ? { id: "", name: "" }
        : value?.acquisition_contact || { id: "", name: "" },

      disposition_contact: value?.disposition_contact?.id === null
        ? { id: "", name: "" }
        : value?.disposition_contact || { id: "", name: "" },

      advisor: value?.advisor || "",
      status: value?.status || "",

      // Date fields (Tab 2)
      created_at: value?.created_at || "",
      created_start_date: value?.created_start_date || "",
      created_end_date: value?.created_end_date || "",

      under_contract_created_at: value?.under_contract_created_at || "",
      under_contract_created_start_date: value?.under_contract_created_start_date || "",
      under_contract_created_end_date: value?.under_contract_created_end_date || "",

      closed_expected_created_at: value?.closed_expected_created_at || "",
      closed_expected_created_start_date: value?.closed_expected_created_start_date || "",
      closed_expected_created_end_date: value?.closed_expected_created_end_date || "",

      // === Tab 3 Fields ===
      lease_type_count: value?.lease_type_count || "",
      lease_type_start_count: value?.lease_type_start_count || "",
      lease_type_end_count: value?.lease_type_end_count || "",

      count: value?.count || "",
      start_count: value?.start_count || "",
      end_count: value?.end_count || "",

      noi: value?.noi || "",

      min_contract_price: value?.min_contract_price || "",
      max_contract_price: value?.max_contract_price || "",

      min_contract_cap_rate: value?.min_contract_cap_rate || "",
      max_contract_cap_rate: value?.max_contract_cap_rate || "",

      min_asking_price: value?.min_asking_price || "",
      max_asking_price: value?.max_asking_price || "",
    };

    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);

    const cleanPayload = getCleanPayload(dataToSet);
    onCallApiAgain(cleanPayload);
  };
 
  const saveSearchFilterData = {
    current_phase: filterData?.current_phase,
    next_action: filterData?.next_action,
    property: filterData?.property,
    contact: filterData?.contact,
    acquisition_contact: filterData?.acquisition_contact,
    disposition_contact: filterData?.disposition_contact,
    advisor: filterData?.advisor,
    status: filterData?.status,

    // Date fields
    created_at: filterData?.created_at,
    created_start_date: filterData?.created_start_date,
    created_end_date: filterData?.created_end_date,
    under_contract_created_at: filterData?.under_contract_created_at,
    under_contract_created_start_date: filterData?.under_contract_created_start_date,
    under_contract_created_end_date: filterData?.under_contract_created_end_date,
    closed_expected_created_at: filterData?.closed_expected_created_at,
    closed_expected_created_start_date: filterData?.closed_expected_created_start_date,
    closed_expected_created_end_date: filterData?.closed_expected_created_end_date,

    // Tab 3 fields
    lease_type_count: filterData?.lease_type_count,
    lease_type_start_count: filterData?.lease_type_start_count,
    lease_type_end_count: filterData?.lease_type_end_count,

    count: filterData?.count,
    start_count: filterData?.start_count,
    end_count: filterData?.end_count,

    noi: filterData?.noi,

    min_contract_price: filterData?.min_contract_price,
    max_contract_price: filterData?.max_contract_price,

    min_contract_cap_rate: filterData?.min_contract_cap_rate,
    max_contract_cap_rate: filterData?.max_contract_cap_rate,

    min_asking_price: filterData?.min_asking_price,
    max_asking_price: filterData?.max_asking_price,
  };

  return (
    <div>
      <SavedFilterComponent
        from={from}
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialContractCloseFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          onSetFilterData(initialContractCloseFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        from={from}
        desc={`Enter Contract To Close information.`}
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ContractCloseFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={filterData}
          activeTab={activeTab}
          onSetFilterData={onSetFilterData}
          onCallApiAgain={onCallApiAgain}
          from={from}
        />
      </RightModal>
    </div>
  );
};

export default ContractCloseFilter;